export enum CourseOfferType {
  OTS_FREE_LIVE = 'OTS_FREE_LIVE',
  OTS_LIVE = 'OTS_LIVE',
  OTS_DEVELOPMENT = 'OTS_DEVELOPMENT',
  ENTERPRISE_LIVE = 'ENTERPRISE_LIVE',
  ENTERPRISE_DEVELOPMENT = 'ENTERPRISE_DEVELOPMENT',
  SANDBOX = 'SANDBOX',
  IMPORTED_CUSTOM_COURSE = 'IMPORTED_CUSTOM_COURSE',
}

export interface ICourse {
  id: number;
  name: string;
  shortName: string;
  shortDescription?: string;
  description?: string;
  color: string;
  secondaryColor: string;
  documentUrl?: string;
  previewMediaUrls: string[];
  offerType: CourseOfferType;
  pricePerSeatInCents?: number;
  stripeProductId?: string;
  previewUrl?: string;
  hasAutomatedContinuousLearning: boolean;
  isDeleted: boolean;
  companyId?: number;
  positivityScore?: number;
  learnerRatings?: number;
  enablesPhishing: boolean;
  createdBy: number;
  updatedBy: number;
  updatedAt: string;
}
